<template>
  <div>
    <h6 class="attribute-listing-filters-group-name">{{ group.attributeGroupName }}</h6>
    <div
      class="attribute-listing-filters-attribute-entries"
      :class="getAttributeEntriesClassName"
    >
      <EntryFilter
        v-for="attributeEntry in entries"
        :key="attributeEntry.id"
        :entry="attributeEntry"
        :group="group"
        class="attribute-listing-filters-attribute-entry"
      >
      </EntryFilter>
    </div>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  props: {
    group: {
      attributeDisplayType: '',
      attributeGroupId: '',
      attributeGroupName: null,
      attributeGroupStep: 0,
      attributeGroupDisplayPosition: 0,
      attributes: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getAttributeEntriesClassName () {
      let className = ''
      if (!this.isBaseGroup) {
        className += 'range_group '
      }
      className += this.group.attributeDisplayType
      return className
    }
  }
}
</script>
